/**
 * Round 10 wow flags (#620 #621 #622) as /api/meta mirrors them (featureFlags.requestTimeline,
 * policySimulator, liveAppCards — the app_setting rows wow.request_timeline, wow.policy_simulator,
 * wow.live_app_cards). A panel whose flag is off renders nothing and never calls its gated route:
 * read the flag first, fetch only when it is on.
 */
import { useMeta } from '@/app/meta';

/** R13 adds deepLinks, density (wow.deep_links, wow.density). R12 adds whereIsIt, shadowReport (wow.where_is_it, wow.shadow_report). R11 adds appSetupWizard, portalSearch, importMapping (wow.app_setup_wizard, wow.portal_search, wow.import_mapping). */
export type CoreWowFlag = 'requestTimeline' | 'policySimulator' | 'liveAppCards' | 'appSetupWizard' | 'portalSearch' | 'importMapping' | 'whereIsIt' | 'shadowReport' | 'deepLinks' | 'density' | 'evidenceDropOnRows';

/** True only when meta says true; a meta from before these flags existed reads as off. Pure. */
export function coreWowFlagOn(featureFlags: unknown, flag: CoreWowFlag): boolean {
  return typeof featureFlags === 'object' && featureFlags !== null && (featureFlags as Record<string, unknown>)[flag] === true;
}

export function useCoreWowFlag(flag: CoreWowFlag): boolean {
  return coreWowFlagOn(useMeta().featureFlags, flag);
}
